import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Card,
  CardContent,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ToastContainer, toast } from "react-toastify";
import {
  createDailyParaDippingCell,
  getDailyParaOfDippingCellDetails,
  approveDippingCell,
} from "./Services";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import Button from "../../components/Button/Button";

const DippingCells = () => {
  const [isApproved, setIsApproved] = useState(false);
  const [dippingData, setDippingData] = useState([]);
  const [dippingType, setDippingType] = useState("");
  const [dippingId, setDippingId] = useState("");
  const [checkedRows, setCheckedRows] = useState({});

  useEffect(() => {
    // Initialize checkedRows based on API data
    if (dippingData?.daily_dipping_range) {
      const newCheckedRows = {};

      // Initialize range rows
      dippingData.daily_dipping_range.forEach((range) => {
        const key = range.range_type === 0 ? "Range_minimum" : "Range_maximum";
        newCheckedRows[key] = range.is_submitted || false;
      });

      // Initialize dipping tank rows - Fix: Use position as the index
      dippingData?.daily_dipping_tank?.forEach((tank) => {
        newCheckedRows[`DippingTank_${tank.position}`] =
          tank.is_submitted || false;
      });

      // Initialize maturation tank rows - Fix: Use position as the index
      dippingData?.daily_maturation_tank?.forEach((tank) => {
        newCheckedRows[`MaturationTank_${tank.position}`] =
          tank.is_submitted || false;
      });

      setCheckedRows(newCheckedRows);
    }
  }, [dippingData]);

  const [rowData, setRowData] = useState({
    range: {
      minimum: {},
      maximum: {},
    },
    dippingTank: {},
    maturationTank: {},
  });

  const DEFAULT_TANK_NAMES = {
    DippingTank: ["D1", "D5", "D6"],
    MaturationTank: {
      static: ["M1", "M2", "M3", "M4"],
    },
  };
  console.log("rowData", rowData);

  const { username, is_supervisor } = useSelector((state) => state.userState);

  console.log("dippingDatadippingData", dippingData);

  const notifyError = (message) =>
    toast.error(message, {
      theme: "colored",
      position: toast.POSITION.TOP_RIGHT,
      toastClassName: "custom-toast",
    });

  const notify = (message) =>
    toast.success(message, {
      theme: "colored",
      position: toast.POSITION.TOP_RIGHT,
      toastClassName: "custom-toast",
    });

  const navigate = useNavigate();

  useEffect(() => {
    handleGetData();
  }, []);

  const handleGetData = async () => {
    try {
      const resp = await getDailyParaOfDippingCellDetails();
      if (resp.status == 200 || resp.status == 201) {
        setDippingData(resp.data.payload);
      }
    } catch (error) {
      setDippingData([]);
    }
  };

  const getRangeData = (type) => {
    return (
      dippingData?.daily_dipping_range?.find(
        (range) => range.range_type === type
      ) || {}
    );
  };

  const handleApprove = (id, type) => {
    setDippingType(type);
    setDippingId(id);
    if (is_supervisor) {
      setIsApproved(true);
    } else {
      notifyError("You don't have access");
    }
  };

  const handleSubmitData = async () => {
    const params = {
      cell_type: dippingType,
      id: dippingId,
      is_approved: true,
    };
    try {
      const resp = await approveDippingCell(params);
      if (resp.status == 200 || resp.status == 201) {
        handleGetData();
        notify(resp.data.message);
        setIsApproved(false);
      }
    } catch (error) {
      notifyError(error.response.data.message);
      setIsApproved(false);
      console.log("error", error);
    }
  };

  // Get minimum and maximum ranges
  const minimumRange = getRangeData(0);
  const maximumRange = getRangeData(1);

  const ranges = {
    minimum: {
      temp: minimumRange.temp || "",
      ph: minimumRange.ph || "",
      viscosity: minimumRange.viscosity || "",
      maturation: minimumRange.maturation || "",
      plateTest: minimumRange.plate_test || "",
      time: minimumRange.modified_at
        ? dayjs(minimumRange.modified_at).format("HH:mm:ss")
        : "",
      reading: minimumRange.repeated_reading || "",
      operator: minimumRange.operator || username,
      supervisor: minimumRange.supervisor || "",
      is_submitted: minimumRange.is_submitted || false,
      id: minimumRange.id || "",
    },
    maximum: {
      temp: maximumRange.temp || "",
      ph: maximumRange.ph || "",
      viscosity: maximumRange.viscosity || "",
      maturation: maximumRange.maturation || "",
      plateTest: maximumRange.plate_test || "",
      time: maximumRange.modified_at
        ? dayjs(maximumRange.modified_at).format("HH:mm:ss")
        : "",
      reading: maximumRange.repeated_reading || "",
      operator: maximumRange.operator || username,
      supervisor: maximumRange.supervisor || "",
      is_submitted: maximumRange.is_submitted || false,
      id: maximumRange.id || "",
    },
  };

  const handleInputChange = (type, field, value, index, rangeType) => {
    // Create a unique key for the cell
    const cellKey =
      type === "Range"
        ? `${type}_${rangeType}_${field}`
        : `${type}_${index}_${field}`;

    // Check if previous data is saved
    if (type === "Range") {
      if (rangeType === "maximum") {
        // Check if minimum range has any filled fields but not checked
        const minimumData = rowData.range?.minimum || {};
        const hasMinimumData = Object.keys(minimumData).some(
          (key) => key !== "toasterShown" && minimumData[key]
        );

        if (hasMinimumData && !checkedRows["Range_minimum"]) {
          if (!rowData.range?.[rangeType]?.toasterShown?.[field]) {
            toast.warning("Save the manual data", {
              theme: "colored",
              position: toast.POSITION.TOP_RIGHT,
              toastClassName: "custom-toast",
            });
            setRowData((prev) => ({
              ...prev,
              range: {
                ...prev.range,
                [rangeType]: {
                  ...(prev.range?.[rangeType] || {}),
                  toasterShown: {
                    ...(prev.range?.[rangeType]?.toasterShown || {}),
                    [field]: true,
                  },
                },
              },
            }));
          }
          return;
        }
      }
    } else if (type === "DippingTank") {
      // Check if range data is filled but not saved
      const minimumData = rowData.range?.minimum || {};
      const maximumData = rowData.range?.maximum || {};
      const hasRangeData = [
        ...Object.keys(minimumData),
        ...Object.keys(maximumData),
      ].some(
        (key) =>
          key !== "toasterShown" && (minimumData[key] || maximumData[key])
      );

      if (
        hasRangeData &&
        (!checkedRows["Range_minimum"] || !checkedRows["Range_maximum"])
      ) {
        if (!rowData[type]?.[index]?.toasterShown?.[field]) {
          toast.warning("Save the manual data", {
            theme: "colored",
            position: toast.POSITION.TOP_RIGHT,
            toastClassName: "custom-toast",
          });
          setRowData((prev) => ({
            ...prev,
            [type]: {
              ...prev[type],
              [index]: {
                ...(prev[type]?.[index] || {}),
                toasterShown: {
                  ...(prev[type]?.[index]?.toasterShown || {}),
                  [field]: true,
                },
              },
            },
          }));
        }
        return;
      }

      // Check if previous tank data is filled but not saved
      if (index > 0) {
        const prevTankData = rowData[type]?.[index - 1] || {};
        const hasPrevTankData = Object.keys(prevTankData).some(
          (key) => key !== "toasterShown" && prevTankData[key]
        );

        if (hasPrevTankData && !checkedRows[`${type}_${index - 1}`]) {
          if (!rowData[type]?.[index]?.toasterShown?.[field]) {
            toast.warning(`Save the manual data`, {
              theme: "colored",
              position: toast.POSITION.TOP_RIGHT,
              toastClassName: "custom-toast",
            });
            setRowData((prev) => ({
              ...prev,
              [type]: {
                ...prev[type],
                [index]: {
                  ...(prev[type]?.[index] || {}),
                  toasterShown: {
                    ...(prev[type]?.[index]?.toasterShown || {}),
                    [field]: true,
                  },
                },
              },
            }));
          }
          return;
        }
      }
    } else if (type === "MaturationTank") {
      // Check if all dipping tanks are saved
      const dippingTankCount = dippingData?.daily_dipping_tank?.length || 0;
      const lastDippingTankData =
        rowData.DippingTank?.[dippingTankCount - 1] || {};
      const hasLastDippingTankData = Object.keys(lastDippingTankData).some(
        (key) => key !== "toasterShown" && lastDippingTankData[key]
      );

      if (
        hasLastDippingTankData &&
        !checkedRows[`DippingTank_${dippingTankCount - 1}`]
      ) {
        if (!rowData[type]?.[index]?.toasterShown?.[field]) {
          toast.warning("Save the manual data", {
            theme: "colored",
            position: toast.POSITION.TOP_RIGHT,
            toastClassName: "custom-toast",
          });
          setRowData((prev) => ({
            ...prev,
            [type]: {
              ...prev[type],
              [index]: {
                ...(prev[type]?.[index] || {}),
                toasterShown: {
                  ...(prev[type]?.[index]?.toasterShown || {}),
                  [field]: true,
                },
              },
            },
          }));
        }
        return;
      }

      // Check if previous maturation tank data is filled but not saved
      if (index > 0) {
        const prevTankData = rowData[type]?.[index - 1] || {};
        const hasPrevTankData = Object.keys(prevTankData).some(
          (key) => key !== "toasterShown" && prevTankData[key]
        );

        if (hasPrevTankData && !checkedRows[`${type}_${index - 1}`]) {
          if (!rowData[type]?.[index]?.toasterShown?.[field]) {
            toast.warning(`Save the manual data`, {
              theme: "colored",
              position: toast.POSITION.TOP_RIGHT,
              toastClassName: "custom-toast",
            });
            setRowData((prev) => ({
              ...prev,
              [type]: {
                ...prev[type],
                [index]: {
                  ...(prev[type]?.[index] || {}),
                  toasterShown: {
                    ...(prev[type]?.[index]?.toasterShown || {}),
                    [field]: true,
                  },
                },
              },
            }));
          }
          return;
        }
      }
    }

    // Reset toaster flag when input is allowed
    setRowData((prev) => {
      if (type === "Range") {
        return {
          ...prev,
          range: {
            ...prev.range,
            [rangeType]: {
              ...(prev.range?.[rangeType] || {}),
              [field]: value,
              position: index,
              toasterShown: {
                ...(prev.range?.[rangeType]?.toasterShown || {}),
                [field]: false,
              },
            },
          },
        };
      } else {
        return {
          ...prev,
          [type]: {
            ...prev[type],
            [index]: {
              ...(prev[type]?.[index] || {}),
              [field]: value,
              position: index,
              toasterShown: {
                ...(prev[type]?.[index]?.toasterShown || {}),
                [field]: false,
              },
            },
          },
        };
      }
    });
  };

  const handleCheckboxClick = async (type, index, rangeType, id) => {
    const rowKey =
      type === "Range" ? `${type}_${rangeType}` : `${type}_${index}`;
    const isCurrentlyChecked = checkedRows[rowKey] || false;
    const newCheckedState = !isCurrentlyChecked;

    // Update the checkbox state immediately
    setCheckedRows((prev) => ({
      ...prev,
      [rowKey]: newCheckedState,
    }));

    // If unchecking, just return without making API call
    if (!newCheckedState) {
      return;
    }

    try {
      let payload = {};

      if (type === "Range") {
        const rangeData = rowData.range[rangeType];
        const currentRange = ranges[rangeType];

        // Only include non-empty values in payload
        payload = {
          cell_type: "Range",
          range_type: rangeType === "minimum" ? 0 : 1,
          position: rangeType === "minimum" ? 0 : 1,
        };

        // Add fields only if they have values
        // const temp = rangeData.temp || currentRange.temp;
        // const ph = rangeData.ph || currentRange.ph;
        // const viscosity = rangeData.viscosity || currentRange.viscosity;
        // const maturation = rangeData.maturation || currentRange.maturation;
        // const plateTest = rangeData.plateTest || currentRange.plateTest;
        const reading = rangeData.reading || currentRange.reading;

        // if (temp) payload.temp = temp;
        // if (ph) payload.ph = ph;
        // if (viscosity) payload.viscosity = viscosity;
        // if (maturation) payload.maturation = maturation;
        // if (plateTest) payload.plate_test = plateTest;
        if (reading) payload.repeated_reading = reading;
      } else if (type === "DippingTank") {
        const tankData = rowData.DippingTank[index];
        const row = dippingData?.daily_dipping_tank?.[index];

        payload = {
          cell_type: "DippingTank",
          position: index,
          tank_type: DEFAULT_TANK_NAMES.DippingTank[index], // Added tank_type
        };

        // Add non-empty values only
        if (tankData?.tank_type || row?.tank_type)
          payload.tank_type = tankData?.tank_type || row?.tank_type;
        if (tankData?.temp || row?.temp)
          payload.temp = tankData?.temp || row?.temp;
        if (tankData?.ph || row?.ph) payload.ph = tankData?.ph || row?.ph;
        if (tankData?.viscosity || row?.viscosity)
          payload.viscosity = tankData?.viscosity || row?.viscosity;
        if (tankData?.maturation || row?.maturation)
          payload.maturation = tankData?.maturation || row?.maturation;
        if (tankData?.plate_test || row?.plate_test)
          payload.plate_test = tankData?.plate_test || row?.plate_test;
        if (tankData?.repeated_reading || row?.repeated_reading)
          payload.repeated_reading =
            tankData?.repeated_reading || row?.repeated_reading;
      } else if (type === "MaturationTank") {
        const tankData = rowData.MaturationTank[index];
        const row = dippingData?.daily_maturation_tank?.[index];

        payload = {
          cell_type: "MaturationTank",
          position: index,
          tank_type: DEFAULT_TANK_NAMES.MaturationTank.static[index], // Added tank_type
        };

        // Add non-empty values only
        if (tankData?.lot_no || row?.lot_no)
          payload.lot_no = tankData?.lot_no || row?.lot_no;
        if (tankData?.tank_type || row?.tank_type)
          payload.tank_type = tankData?.tank_type || row?.tank_type;
        if (tankData?.temp || row?.temp)
          payload.temp = tankData?.temp || row?.temp;
        if (tankData?.ph || row?.ph) payload.ph = tankData?.ph || row?.ph;
        if (tankData?.viscosity || row?.viscosity)
          payload.viscosity = tankData?.viscosity || row?.viscosity;
        if (tankData?.maturation || row?.maturation)
          payload.maturation = tankData?.maturation || row?.maturation;
        if (tankData?.plate_test || row?.plate_test)
          payload.plate_test = tankData?.plate_test || row?.plate_test;
        if (tankData?.repeated_reading || row?.repeated_reading)
          payload.repeated_reading =
            tankData?.repeated_reading || row?.repeated_reading;
      }

      // Add obj_id if provided
      if (id !== "") {
        payload.obj_id = id;
      }

      // Only make API call if there are fields besides the required ones
      const requiredFields = ["cell_type", "position", "range_type", "obj_id"];
      // const hasAdditionalFields = Object.keys(payload).some(key => !requiredFields.includes(key));

      // if (!hasAdditionalFields) {
      //   notifyError("Please fill in at least one field before saving");
      //   setCheckedRows((prev) => ({
      //     ...prev,
      //     [rowKey]: !newCheckedState,
      //   }));
      //   return;
      // }

      const response = await createDailyParaDippingCell(payload);
      if (response.status === 200 || response.status === 201) {
        notify(response.data.message);
        handleGetData();
      }
    } catch (error) {
      setCheckedRows((prev) => ({
        ...prev,
        [rowKey]: !newCheckedState,
      }));
      notifyError(error.response?.data?.message || "Submission failed");
    }
  };

  const isRowChecked = (type, index, rangeType) => {
    const rowKey =
      type === "Range" ? `${type}_${rangeType}` : `${type}_${index}`;
    return checkedRows[rowKey] || false;
  };

  const inputStyle = {
    width: "100%",
    border: "1px solid #ddd",
    padding: "4px",
  };
  return (
    <div className="page-wraper">
      <ToastContainer />
      <div className="page-header">
        <Link to="/dashboard" className="page-back-btn">
          <ArrowBackIcon />
          <span style={{ width: "max-content" }}>
            Daily Parameter of Dipping Cell
          </span>
        </Link>
      </div>
      <Paper sx={{ width: "100%" }}>
        <TableContainer>
          <Table size="small" className="Table-dipping-cells">
            <TableHead>
              <TableRow sx={{ backgroundColor: "#1d407d" }}>
                <TableCell
                  colSpan={8}
                  align="center"
                  sx={{ color: "white", borderRight: "1px solid white" }}
                >
                  Date:- {dippingData?.date}
                </TableCell>
                <TableCell colSpan={6} align="center" sx={{ color: "white" }}>
                  Shift:-{dippingData?.shift}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={4}>Parameter</TableCell>
                <TableCell>Temp</TableCell>
                <TableCell>PH</TableCell>
                <TableCell>Viscosity</TableCell>
                <TableCell>Maturation</TableCell>
                <TableCell>Plate Test</TableCell>
                <TableCell>Time</TableCell>
                <TableCell>Repeated Reading</TableCell>
                <TableCell sx={{ width: "220px" }}>Operator Name</TableCell>
                <TableCell>Sup(Prod/QA)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* Range Section */}
              <TableRow>
                <TableCell rowSpan={2} colSpan={3}>
                  Range
                </TableCell>
                <TableCell>Minimum</TableCell>

                <TableCell>
                  {/* {" "}
                  <input
                    type="text"
                    defaultValue={ranges.minimum.temp}
                    onChange={(e) =>
                      handleInputChange(
                        "Range",
                        "temp",
                        e.target.value,
                        null,
                        "minimum"
                      )
                    }
                    disabled
                    // disabled={checkedRows?.[`Range_minimum`] || false}
                    style={inputStyle}
                  /> */}
                  {ranges.minimum.temp}
                </TableCell>
                <TableCell>
                  {" "}
                  {/* <input
                    type="text"
                    defaultValue={ranges.minimum.ph}
                    onChange={(e) =>
                      handleInputChange(
                        "Range",
                        "ph",
                        e.target.value,
                        null,
                        "minimum"
                      )
                    }
                    disabled
                    // disabled={checkedRows?.[`Range_minimum`] || false}
                    style={inputStyle}
                  /> */}
                  {ranges.minimum.ph}
                </TableCell>
                <TableCell>
                  {" "}
                  {/* <input
                    type="text"
                    defaultValue={ranges.minimum.viscosity}
                    onChange={(e) =>
                      handleInputChange(
                        "Range",
                        "viscosity",
                        e.target.value,
                        null,
                        "minimum"
                      )
                    }
                    disabled
                    // disabled={checkedRows?.[`Range_minimum`] || false}
                    style={inputStyle}
                  /> */}
                  {ranges.minimum.viscosity}
                </TableCell>
                <TableCell>
                  {/* <input
                    type="text"
                    defaultValue={ranges.minimum.maturation}
                    onChange={(e) =>
                      handleInputChange(
                        "Range",
                        "maturation",
                        e.target.value,
                        null,
                        "minimum"
                      )
                    }
                    disabled
                    // disabled={checkedRows?.[`Range_minimum`] || false}
                    style={inputStyle}
                  /> */}
                  {ranges.minimum.maturation}
                </TableCell>
                <TableCell>
                  {/* <input
                    type="text"
                    defaultValue={ranges.minimum.plateTest}
                    onChange={(e) =>
                      handleInputChange(
                        "Range",
                        "plateTest",
                        e.target.value,
                        null,
                        "minimum"
                      )
                    }
                    disabled
                    // disabled={checkedRows?.[`Range_minimum`] || false}
                    style={inputStyle}
                  /> */}
                  {ranges.minimum.plateTest}
                </TableCell>
                <TableCell>
                  {/* <input
                    type="text"
                    defaultValue={ranges.minimum.time}
                    onChange={(e) =>
                      handleInputChange(
                        "Range",
                        "time",
                        e.target.value,
                        null,
                        "minimum"
                      )
                    }
                    disabled
                    style={inputStyle}
                  /> */}
                  {/* {ranges.minimum.time} */}
                </TableCell>
                <TableCell>
                  {/* <input
                    type="text"
                    defaultValue={ranges.minimum.reading}
                    onChange={(e) =>
                      handleInputChange(
                        "Range",
                        "reading",
                        e.target.value,
                        null,
                        "minimum"
                      )
                    }
                    disabled={checkedRows?.[`Range_minimum`] || false}
                    style={inputStyle}
                  /> */}
                </TableCell>
                <TableCell>
                  {/* <div className="d-flex justify-content-between align-items-center">
                    {ranges.minimum.operator}
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isRowChecked("Range", null, "minimum")}
                          onChange={() =>
                            handleCheckboxClick(
                              "Range",
                              null,
                              "minimum",
                              ranges.minimum.id
                            )
                          }
                          disabled={
                            ranges.minimum.supervisor && !is_supervisor
                              ? true
                              : false
                          }
                        />
                      }
                    />
                  </div> */}
                </TableCell>
                <TableCell>
                  {/* {ranges.minimum.supervisor ? (
                    ranges.minimum.supervisor
                  ) : (
                    <Button
                      variant="contained"
                      size="small"
                      className="dipping-approve-btn"
                      title="Approve"
                      onClick={() => handleApprove(ranges.minimum.id, "Range")}
                      disabled={!isRowChecked("Range", null, "minimum")}
                    ></Button>
                  )} */}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Maximum</TableCell>
                <TableCell>
                  {/* {" "}
                  <input
                    type="text"
                    defaultValue={ranges.maximum.temp}
                    onChange={(e) =>
                      handleInputChange(
                        "Range",
                        "temp",
                        e.target.value,
                        null,
                        "maximum"
                      )
                    }
                    disabled
                    // disabled={checkedRows?.[`Range_maximum`] || false}
                    style={inputStyle}
                  /> */}
                  {ranges.maximum.temp}
                </TableCell>
                <TableCell>
                  {" "}
                  {/* <input
                    type="text"
                    defaultValue={ranges.maximum.ph}
                    onChange={(e) =>
                      handleInputChange(
                        "Range",
                        "ph",
                        e.target.value,
                        null,
                        "maximum"
                      )
                    }
                    disabled
                    // disabled={checkedRows?.[`Range_maximum`] || false}
                    style={inputStyle}
                  /> */}
                  {ranges.maximum.ph}
                </TableCell>
                <TableCell>
                  {" "}
                  {/* <input
                    type="text"
                    defaultValue={ranges.maximum.viscosity}
                    onChange={(e) =>
                      handleInputChange(
                        "Range",
                        "viscosity",
                        e.target.value,
                        null,
                        "maximum"
                      )
                    }
                    disabled
                    //  disabled={checkedRows?.[`Range_maximum`] || false}
                    style={inputStyle}
                  /> */}
                  {ranges.maximum.viscosity}
                </TableCell>
                <TableCell>
                  {/* <input
                    type="text"
                    defaultValue={ranges.maximum.maturation}
                    onChange={(e) =>
                      handleInputChange(
                        "Range",
                        "maturation",
                        e.target.value,
                        null,
                        "maximum"
                      )
                    }
                    disabled
                    //  disabled={checkedRows?.[`Range_maximum`] || false}
                    style={inputStyle}
                  /> */}
                  {ranges.maximum.maturation}
                </TableCell>

                <TableCell>
                  {/* <input
                    type="text"
                    defaultValue={ranges.maximum.plateTest}
                    onChange={(e) =>
                      handleInputChange(
                        "Range",
                        "plateTest",
                        e.target.value,
                        null,
                        "maximum"
                      )
                    }
                    disabled
                    //  disabled={checkedRows?.[`Range_maximum`] || false}
                    style={inputStyle}
                  /> */}
                  {ranges.maximum.plateTest}
                </TableCell>
                <TableCell>
                  {/* <input
                    type="text"
                    defaultValue={ranges.maximum.time}
                    onChange={(e) =>
                      handleInputChange(
                        "Range",
                        "time",
                        e.target.value,
                        null,
                        "maximum"
                      )
                    }
                    disabled
                    style={inputStyle}
                  /> */}
                  {/* {ranges.maximum.time} */}
                </TableCell>
                <TableCell>
                  {/* <input
                    type="text"
                    defaultValue={ranges.maximum.reading}
                    onChange={(e) =>
                      handleInputChange(
                        "Range",
                        "reading",
                        e.target.value,
                        null,
                        "maximum"
                      )
                    }
                    disabled={checkedRows?.[`Range_maximum`] || false}
                    style={inputStyle}
                  /> */}
                </TableCell>
                <TableCell>
                  {/* <div className="d-flex justify-content-between align-items-center">
                    {ranges.maximum.operator}
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isRowChecked("Range", null, "maximum")}
                          onChange={() =>
                            handleCheckboxClick(
                              "Range",
                              null,
                              "maximum",
                              ranges.maximum.id
                            )
                          }
                          disabled={
                            ranges.maximum.supervisor && !is_supervisor
                              ? true
                              : false
                          }
                        />
                      }
                    />
                  </div> */}
                </TableCell>
                <TableCell>
                  {/* {ranges.maximum.supervisor ? (
                    ranges.maximum.supervisor
                  ) : (
                    <Button
                      variant="contained"
                      size="small"
                      className="dipping-approve-btn"
                      title="Approve"
                      onClick={() => handleApprove(ranges.maximum.id, "Range")}
                      disabled={!isRowChecked("Range", null, "maximum")}
                    ></Button>
                  )} */}
                </TableCell>
              </TableRow>

              {/* Dipping Tank Section */}
              {[...Array(3)].map((_, index) => {
                const row = dippingData?.daily_dipping_tank?.find(
                  (tank) => tank.position === index
                ) || {
                  position: index,
                };

                console.log("rowfdgdfgdf", row);
                return (
                  <TableRow key={row?.position || index}>
                    {index === 0 && (
                      <TableCell rowSpan={3} colSpan={3}>
                        Dipping Tank
                      </TableCell>
                    )}
                    <TableCell>
                      {DEFAULT_TANK_NAMES.DippingTank[index] || row?.temp}
                    </TableCell>
                    <TableCell>
                      <input
                        type="text"
                        defaultValue={row?.temp}
                        onChange={(e) =>
                          handleInputChange(
                            "DippingTank",
                            "temp",
                            e.target.value,
                            index,
                            "dippingTank"
                          )
                        }
                        disabled={
                          checkedRows?.[`DippingTank_${index}`] || false
                        }
                        style={inputStyle}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        type="text"
                        defaultValue={row?.ph}
                        onChange={(e) =>
                          handleInputChange(
                            "DippingTank",
                            "ph",
                            e.target.value,
                            index,
                            "dippingTank"
                          )
                        }
                        disabled={
                          checkedRows?.[`DippingTank_${index}`] || false
                        }
                        style={inputStyle}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        type="text"
                        defaultValue={row?.viscosity}
                        onChange={(e) =>
                          handleInputChange(
                            "DippingTank",
                            "viscosity",
                            e.target.value,
                            index,
                            "dippingTank"
                          )
                        }
                        disabled={
                          checkedRows?.[`DippingTank_${index}`] || false
                        }
                        style={inputStyle}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        type="text"
                        defaultValue={row?.maturation}
                        onChange={(e) =>
                          handleInputChange(
                            "DippingTank",
                            "maturation",
                            e.target.value,
                            index,
                            "dippingTank"
                          )
                        }
                        disabled={
                          checkedRows?.[`DippingTank_${index}`] || false
                        }
                        style={inputStyle}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        type="text"
                        defaultValue={row?.plate_test}
                        onChange={(e) =>
                          handleInputChange(
                            "DippingTank",
                            "plate_test",
                            e.target.value,
                            index,
                            "dippingTank"
                          )
                        }
                        disabled={
                          checkedRows?.[`DippingTank_${index}`] || false
                        }
                        style={inputStyle}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        type="text"
                        defaultValue={
                          row?.modified_at
                            ? dayjs(row.modified_at).format("HH:mm:ss")
                            : ""
                        }
                        onChange={(e) =>
                          handleInputChange(
                            "DippingTank",
                            "modified_at",
                            e.target.value,
                            index,
                            "dippingTank"
                          )
                        }
                        disabled
                        style={inputStyle}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        type="text"
                        defaultValue={row?.repeated_reading}
                        onChange={(e) =>
                          handleInputChange(
                            "DippingTank",
                            "repeated_reading",
                            e.target.value,
                            index,
                            "dippingTank"
                          )
                        }
                        disabled={
                          checkedRows?.[`DippingTank_${index}`] || false
                        }
                        style={inputStyle}
                      />
                    </TableCell>
                    <TableCell>
                      <div className="d-flex justify-content-between align-items-center">
                        {row?.operator || username}
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={isRowChecked(
                                "DippingTank",
                                index,
                                "dippingTank"
                              )}
                              onChange={() =>
                                handleCheckboxClick(
                                  "DippingTank",
                                  index,
                                  "dippingTank",
                                  row.id
                                )
                              }
                              disabled={
                                row?.supervisor && !is_supervisor ? true : false
                              }
                            />
                          }
                        />
                      </div>
                    </TableCell>
                    <TableCell>
                      {row?.supervisor ? (
                        row?.supervisor
                      ) : (
                        <Button
                          variant="contained"
                          size="small"
                          className="dipping-approve-btn"
                          title="Approve"
                          onClick={() => handleApprove(row.id, "DippingTank")}
                          disabled={!isRowChecked("DippingTank", index)}
                        ></Button>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}

              {/* Maturation Tank Section */}
              {[...Array(4)].map((_, index) => {
                const row = dippingData?.daily_maturation_tank?.find(
                  (tank) => tank.position === index
                ) || {
                  position: index,
                };
                return (
                  <TableRow key={row?.position || index}>
                    {index === 0 && (
                      <>
                        <TableCell rowSpan={6}>Maturation Tank</TableCell>
                        <TableCell rowSpan={6}>Lot No.</TableCell>
                      </>
                    )}
                    <TableCell>
                      {" "}
                      <input
                        type="text"
                        defaultValue={row?.lot_no || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "MaturationTank",
                            "lot_no",
                            e.target.value,
                            index,
                            "maturationTank"
                          )
                        }
                        disabled={
                          checkedRows?.[`MaturationTank_${index}`] || false
                        }
                        style={inputStyle}
                      />
                    </TableCell>
                    <TableCell>
                      {index <
                        DEFAULT_TANK_NAMES.MaturationTank.static.length &&
                        DEFAULT_TANK_NAMES.MaturationTank.static[index]}
                    </TableCell>
                    <TableCell>
                      <input
                        type="text"
                        defaultValue={row?.temp}
                        onChange={(e) =>
                          handleInputChange(
                            "MaturationTank",
                            "temp",
                            e.target.value,
                            index,
                            "maturationTank"
                          )
                        }
                        disabled={
                          checkedRows?.[`MaturationTank_${index}`] || false
                        }
                        style={inputStyle}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        type="text"
                        defaultValue={row?.ph}
                        onChange={(e) =>
                          handleInputChange(
                            "MaturationTank",
                            "ph",
                            e.target.value,
                            index,
                            "maturationTank"
                          )
                        }
                        disabled={
                          checkedRows?.[`MaturationTank_${index}`] || false
                        }
                        style={inputStyle}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        type="text"
                        defaultValue={row?.viscosity}
                        onChange={(e) =>
                          handleInputChange(
                            "MaturationTank",
                            "viscosity",
                            e.target.value,
                            index,
                            "maturationTank"
                          )
                        }
                        disabled={
                          checkedRows?.[`MaturationTank_${index}`] || false
                        }
                        style={inputStyle}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        type="text"
                        defaultValue={row?.maturation}
                        onChange={(e) =>
                          handleInputChange(
                            "MaturationTank",
                            "maturation",
                            e.target.value,
                            index,
                            "maturationTank"
                          )
                        }
                        disabled={
                          checkedRows?.[`MaturationTank_${index}`] || false
                        }
                        style={inputStyle}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        type="text"
                        defaultValue={row?.plate_test}
                        onChange={(e) =>
                          handleInputChange(
                            "MaturationTank",
                            "plate_test",
                            e.target.value,
                            index,
                            "maturationTank"
                          )
                        }
                        disabled={
                          checkedRows?.[`MaturationTank_${index}`] || false
                        }
                        style={inputStyle}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        type="text"
                        defaultValue={
                          row?.modified_at
                            ? dayjs(row.modified_at).format("HH:mm:ss")
                            : ""
                        }
                        disabled
                        onChange={(e) =>
                          handleInputChange(
                            "MaturationTank",
                            "modified_at",
                            e.target.value,
                            index,
                            "maturationTank"
                          )
                        }
                        style={inputStyle}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        type="text"
                        defaultValue={row?.repeated_reading}
                        onChange={(e) =>
                          handleInputChange(
                            "MaturationTank",
                            "repeated_reading",
                            e.target.value,
                            index,
                            "maturationTank"
                          )
                        }
                        disabled={
                          checkedRows?.[`MaturationTank_${index}`] || false
                        }
                        style={inputStyle}
                      />
                    </TableCell>
                    <TableCell>
                      <div className="d-flex justify-content-between align-items-center">
                        {row?.operator || username}
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={isRowChecked(
                                "MaturationTank",
                                index,
                                "maturationTank"
                              )}
                              disabled={
                                row?.supervisor && !is_supervisor ? true : false
                              }
                              onChange={() =>
                                handleCheckboxClick(
                                  "MaturationTank",
                                  index,
                                  "maturationTank",
                                  row.id ? row.id : ""
                                )
                              }
                            />
                          }
                        />
                      </div>
                    </TableCell>
                    <TableCell>
                      {row?.supervisor ? (
                        row?.supervisor
                      ) : (
                        <Button
                          variant="contained"
                          size="small"
                          className="dipping-approve-btn"
                          title="Approve"
                          onClick={() =>
                            handleApprove(row.id, "MaturationTank")
                          }
                          disabled={!isRowChecked("MaturationTank", index)}
                        ></Button>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <button
        className="pt-2 next-btn"
        onClick={() => navigate("/dipping-coagulant")}
      >
        Next
      </button>
      {isApproved && (
        <div className="sendingdataaaa1">
          <Card className="pairingcard-Approved">
            <CardContent className="p-0 pairing-status">
              <h4>Are you sure you want to Approve?</h4>
            </CardContent>
            <button className="pairingcard-btn" onClick={handleSubmitData}>
              Yes
            </button>
            <button
              className="pairingcard-btn"
              onClick={() => setIsApproved(false)}
            >
              No
            </button>
          </Card>
        </div>
      )}
    </div>
  );
};

export default DippingCells;
